import { useEffect, useState } from 'react';

// True at Tailwind's `lg` breakpoint and wider, where the desktop layout starts.
const QUERY = '(min-width: 1024px)';

export function useIsDesktop() {
  const [desktop, setDesktop] = useState(() => window.matchMedia(QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = () => setDesktop(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return desktop;
}
